<button mat-stroked-button>
  <mat-icon>file</mat-icon>
</button>